import styled from "styled-components"

export const TourWrapper = styled.div`
    .admin_tour_control {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #e9e9e9;
        height: 60px;
        border-radius: 4px;
        &_sort-add {
            display: flex;
            select {
                height: 35px;
                width: 120px;
                border: 1px solid #e2c1c1;
                background-color: #fff;
                outline: none;
                text-align: center;
                cursor: pointer;
                border-radius: 4px;
            }
        }
    }
    .btn_add{
        width: 60px;
        height: 35px;
    }
    .btn-action{
        height: 35px;
        width: 35px;
        margin-top: 4px;
    }
    .admin_tour_table {
        position: relative;
    }
    .admin_tour_pagination {
        display: flex;
        justify-content: space-between;
        &_total_item {
            color: #1c1c1c;
            margin-left: 12px;
        }
    }
`
